import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parent-layout',
  templateUrl: './parent-layout.component.html',
  styles: [
  ]
})
export class ParentLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
